import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

export default class ButtonDeny extends Component {
  _onClick(event) {
    this.props.handler();
  }

  render() {
    return (
      <div className={css(styles.container)} onClick={this._onClick.bind(this)}>
        <div className={css(styles.text)}>{this.props.title}</div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    paddingTop: 20,
    paddingBottom: 20,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    width: 200,
    textAlign: 'center',
    border: `2px solid ${Theme.primary}`,
    boxSizing: 'border-box',
    transition: 'all 200ms ease-in-out',
    ':hover': {
      opacity: 0.5,
    },
  },
  text: {
    fontFamily: Theme.fontFamily_secondary,
    letterSpacing: 2,
    fontSize: 14,
    color: Theme.primary,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/components/ButtonDeny/index.js